module.exports = {"id":"167661","name":"Jesús Méndez","rating":"72","photo":"./data/images/photos/3/167661.png","club":{"name":"Vélez Sarsfield","logo":"./data/images/clubs/VelezSarsfield.png"},"positions":["MC","MDC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JesusMendez0.json
// module id = 2008
// module chunks = 0